import React from 'react';
import Link from 'next/link';
import { CustomLink } from '@/components/Common/Table/Table.styled';
import TextOverFlow from '@/components/Common/TextOverFlow';
import { RankInRankT } from '@/types/league';

function RankTableBody({ data, from }: RankInRankT) {
  return (
    <>
      {data
        .filter(d => d.summoner)
        .map(
          (
            { id, wins, losses, league_points, tier, summoner },
            idx: number
          ) => (
            <tr key={id}>
              <td>{idx + from}</td>
              <td>
                <Link href={`/records/${summoner?.name}`} passHref>
                  <CustomLink>
                    <TextOverFlow width={100} title={summoner?.name}>
                      {summoner?.name}
                    </TextOverFlow>
                  </CustomLink>
                </Link>
              </td>
              <td>{tier}</td>
              <td>{summoner?.summoner_level}</td>
              <td>{league_points}</td>
              <td>{Math.floor((wins / (losses + wins)) * 100)}%</td>
              <td>{wins}</td>
              <td>{losses}</td>
            </tr>
          )
        )}
    </>
  );
}

export default RankTableBody;
